export default "__VITE_ASSET__AouYnbjs__"